// libraries
import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames/bind";

import { Logo } from "src/components";

// assets
import logo from "src/assets/images/logo/logo.svg";
import location from "src/assets/images/footer/location.svg";
import email from "src/assets/images/footer/email.svg";
import facebook from "src/assets/images/footer/facebook.svg";
import twitter from "src/assets/images/footer/twitter.svg";
import instagram from "src/assets/images/footer/instagram.svg";
import linkedin from "src/assets/images/footer/linkedin.svg";
import youtube from "src/assets/images/footer/youtube.svg";
import playStore from "src/assets/images/register/play_store.svg";
import appStore from "src/assets/images/register/app_store.svg";

// animation
import FadeTop from "src/components/Animation/FadeTop";
import FadeRight from "src/components/Animation/FadeRight";
import FadeLeft from "src/components/Animation/FadeLeft";

// styles
import styles from "./styles.module.scss";
const cx = classNames.bind(styles);

const Footer = () => {
  return (
    <div className={cx("footer")}>
      <div className={cx("wrap")}>
        <div className={cx("head")}>
          {/* <img src={logo} alt="logo" /> */}
          <Logo />
          <span>
            Global platform for live experiences that allow anyone to
            create,share and attend events.
          </span>
        </div>
        <div className={cx("body")}>
          <div className={cx("content")}>
            <div className={cx("links")}>
              <div>
                <h6>Quick Links</h6>
                <Link to="/">About Us</Link>
                <Link to="/">Careers</Link>
                <Link to="/">Help</Link>
                <Link to="/">Terms,Privacy & Cookies</Link>
              </div>
              <div>
                <h6>Event Blog</h6>
                <Link to="/">Event By Venue</Link>
                <Link to="/">Gift Cards</Link>
                <Link to="/">Last Minute Services</Link>
                <Link to="/">Notifications</Link>
              </div>
            </div>
            <div className={cx("contact")}>
              <h6>Contact Us</h6>
              <div>
                <img src={location} alt="location" />
                <span>Eventmoon 260 Wolcott ST New Haven CT 06510</span>
              </div>
              <div>
                <img src={email} alt="email" />
                <span>
                  <a
                    href="mailto:contact@eventmoon.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    contact@eventmoon.com
                  </a>
                </span>
              </div>
            </div>
          </div>
          <div className={cx("social_links")}>
            <h6>Follow us </h6>
            <div className={cx("wrapper")}>
              <span>
                <FadeTop duration={0.5} y={20}>
                  <a
                    href="https://www.facebook.com/eventmoonapp/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={facebook} alt="facebook" />
                  </a>
                </FadeTop>
              </span>
              <span>
                <FadeTop duration={0.5} y={20}>
                  <a
                    href="https://www.instagram.com/eventfindingapp/?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={instagram} alt="instagram" />
                  </a>
                </FadeTop>
              </span>
              <span>
                <FadeTop duration={0.5} y={20}>
                  <a
                    href="https://www.linkedin.com/company/eventmoon/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={linkedin} alt="linkedin" />
                  </a>
                </FadeTop>
              </span>
              <span>
                <FadeTop duration={0.5} y={20}>
                  <a
                    href="https://twitter.com/eventmoonapp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={twitter} alt="twitter" />
                  </a>
                </FadeTop>
              </span>
              <span>
                <FadeTop duration={0.5} y={20}>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <img src={youtube} alt="youtube" />
                  </a>
                </FadeTop>
              </span>
            </div>
          </div>
          <div className={cx("rights")}>
            <p>
              © 2020 Eventmoon. All Rights Reserved. Use Of This Website
              Signifies Your Agreement To Our User Agreement, Privacy Notice And
              Cookie Notice. You Are Buying Tickets From A Third Party; Stubhub
              Is Not The Ticket Seller. Prices Are Set By Sellers And May Be
              Above Face Value. User Aggrement Change Notifications.
            </p>
            <span>
              <FadeRight duration={0.5}>
                <a
                  href="https://play.google.com/store/apps/details?id=com.music_event_app&hl=en_US&gl=US"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={playStore} alt="play_store" />
                </a>
              </FadeRight>
              <FadeLeft duration={0.5}>
                <a
                  href="https://apps.apple.com/us/app/event-moon/id1317300725"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={appStore} alt="app_store" />
                </a>
              </FadeLeft>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
